import { createStore } from 'vuex';
// eslint-disable-next-line import/no-named-as-default
import { Modal } from 'bootstrap';
import Query from '@/assets/js/fisQuery_v1';
import User from '../assets/js/fisUser_v1';
import { Location } from '../assets/js/fisLocation_v1';

export default createStore({
  state: {
    baseUrl: null,
    servicesPath: '/data/cur/',
    servicesBaseUrl: null,
    appRoot: 'fws',
    application: {
      acronym: 'FWS',
      name: 'Facilities Work Search',
      links: [],
    },
    searchLink: {
      id: 'search-nav',
      routerLink: '/search',
      name: 'Search',
      svgs: [
        {
          id: '1',
          svg: 'M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z',
        },
      ],
    },
    preferencesLink: {
      id: 'preferences-nav',
      routerLink: '/preferences',
      name: 'Preferences',
      svgs: [
        {
          id: '2',
          svg: 'M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z',
        },
      ],
    },
    errorObject: { title: 'Error', body: 'Error Message' },
    user: new User(),
    impersonateNetId: null,
    loadingStatus: 'Please wait while the login process starts.',
    loginReady: false,
    appReady: false,
    buildings: [],
    location: Location.location(),
    query: new Query(),
  },
  getters: {
    application(state) {
      return state.application;
    },
    baseUrl(state) {
      return state.baseUrl;
    },
    getUrlParameter: (state) => (parameterName) => {
      const url = new URL(state.baseUrl.toString());
      return url.searchParams.get(parameterName);
    },
    haveUrlParameter: (state) => (parameterName) => {
      const url = new URL(state.baseUrl.toString());
      const parameter = url.searchParams.get(parameterName);
      if (parameter == null) return false;
      return true;
    },
    originationUrl(state) {
      const originationUrl = new URL(state.baseUrl.toString());

      // remove the ticket parameters if it exists
      originationUrl.searchParams.delete('ticket');

      return originationUrl.toString();
    },
    fetchPath: (state) => (subPath) => state.servicesBaseUrl + subPath,
    user(state) {
      return state.user;
    },
    impersonateNetId(state) {
      return state.impersonateNetId;
    },
    token(state) {
      return state.user.token;
    },
    servicesPath(state) {
      return state.servicesPath;
    },
    loginReady(state) {
      return state.loginReady;
    },
    loadingStatus(state) {
      return state.loadingStatus;
    },
    appReady(state) {
      return state.appReady;
    },
    errorObject(state) {
      return state.errorObject;
    },
    buildings(state) {
      return state.buildings;
    },
    location(state) {
      return state.location;
    },
    query(state) {
      return state.query;
    },
  },
  mutations: {
    user(state, user) {
      // console.log("saving user");
      state.user = new User(user);

      state.user.userBuildings
        // eslint-disable-next-line no-nested-ternary
        .sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));

      state.query.removeFilterItem('userBuildings');
      state.query.removeFilterItem('w.bldg');
      state.query.removeFilterItem('p.location_code');

      if (typeof state.user !== 'undefined') {
        state.query.alterFilterItem('w.contact_mc', state.user.person.email, 1);

        if (typeof state.user.userBuildings !== 'undefined' && state.user.userBuildings.length > 0) {
          state.location.facid = '0';
          let bldgs = '';
          state.user.userBuildings.forEach((bldg) => { bldgs += (`${bldg.facid}\t`); });
          state.query.alterFilterItem('w.bldg', bldgs, 5);
        } else {
          state.location.facid = '0000';
        }
      }
    },
    impersonateNetId(state, impersonateNetId) {
      state.impersonateNetId = impersonateNetId;
    },
    baseUrl(state, url) {
      state.baseUrl = url;

      state.servicesBaseUrl = `${url.protocol}//${url.host}/${url.pathname.split('/')[1]}`;
      // console.log("servicesBaseUrl : " + state.servicesBaseUrl);
      if (typeof process.env.VUE_APP_API_ENDPOINT !== 'undefined') {
        console.log(
          `process.env.VUE_APP_API_ENDPOINT : ${
            process.env.VUE_APP_API_ENDPOINT}`,
        );
        state.servicesBaseUrl = `${process.env.VUE_APP_API_ENDPOINT}`;
      }
      // console.log("servicesBaseUrl : " + state.servicesBaseUrl);

      // add the services extension
      state.servicesBaseUrl += state.servicesPath;
      // console.log("servicesBaseUrl : " + state.servicesBaseUrl);
    },
    loginReady(state, loginReady) {
      state.loginReady = loginReady;
    },
    appReady(state, appReady) {
      state.appReady = appReady;
    },
    loadingStatus(state, loadingStatus) {
      state.loadingStatus = loadingStatus;
    },
    errorObject(state, errorObject) {
      state.errorObject = errorObject;
    },
    buildings(state, buildings) {
      state.buildings = buildings;
    },
    location(state, location) {
      state.location = location;
    },
    query(state, query) {
      state.query = query;
    },
  },
  actions: {
    addUserLinks(context) {
      context.state.application.links = [];
      context.state.application.links.push(context.state.searchLink);
      context.state.application.links.push(context.state.preferencesLink);
      // if (context.state.user.hasRole('admin'))
      // context.state.application.links.push(context.state.adminLink);
    },
    removeTicketFromURL(context) {
      context.state.baseUrl.searchParams.delete('ticket');
      history.replaceState(null, '', context.state.baseUrl.toString());
    },
    processError(context, errorTitle, errorMessage) {
      context.state.errorObject = {
        title: errorTitle,
        body: errorMessage,
      };

      // eslint-disable-next-line no-unused-vars
      const errorModal = new Modal(
        document.getElementById('errorModal'),
        {},
      );
      // errorModal.show();
    },
    updateUserBuildings(context, userBuildings) {
      context.state.user.userBuildings = userBuildings;
    },
    updateBuilding(context, newBuilding) {
      for (let i = 0; i < context.state.buildings.length; i++) {
        if (context.state.buildings[i].facid == newBuilding.facid) {
          context.state.buildings[i] = newBuilding;
          break;
        }
      }
    },
  },
  modules: {
  },
});
